import React from "react";
import styles from "./InvoiceSections.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

interface ILineItem {
  name: string;
  description: string;
  uom: string;
  quantity: number;
  type: "Material" | "Labor";
  cost: string;
  markup: number;
  price: number;
  tax: string;
  amount: number;
}
export interface ISectionsTableInInvoiceSections {
  title: string;
  lines: ILineItem[];
}

interface IInvoiceSectionsProps {
  sectionsTable: ISectionsTableInInvoiceSections[] | null;
}

const InvoiceSections = (props: IInvoiceSectionsProps) => {
  return (
    <div className={cx("sections-container")}>
      <div className={cx("table-wrapper")}>
        <table className={cx("sections-table")}>
          <thead>
            <tr>
              <th className={cx("col-name")}>
                {props?.sectionsTable?.[0]?.title || "Item"}
              </th>
              <th className={cx("col-description")}>Description</th>
              <th className={cx("col-uom")}>UOM</th>
              <th className={cx("col-quantity")}>Quantity</th>
              <th className={cx("col-type")}>L/M</th>
              <th className={cx("col-cost")}>Cost</th>
              <th className={cx("col-markup")}>Markup</th>
              <th className={cx("col-price")}>Price</th>
              <th className={cx("col-tax")}>Tax</th>
              <th className={cx("col-amount")}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {props?.sectionsTable?.map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                {sectionIndex > 0 && section.title && (
                  <tr className={cx("section-header-row")}>
                    <td colSpan={10} className={cx("section-header")}>
                      {section.title}
                    </td>
                  </tr>
                )}
                {section.lines.map((line, lineIndex) => (
                  <tr key={lineIndex} className={cx("item-row")}>
                    <td className={cx("col-name")}>{line.name}</td>
                    <td className={cx("col-description")}>
                      {line.description}
                    </td>
                    <td className={cx("col-uom")}>{line.uom}</td>
                    <td className={cx("col-quantity")}>
                      {line.quantity.toFixed(2)}
                    </td>
                    <td className={cx("col-type")}>
                      {line.type === "Material" ? "M" : "L"}
                    </td>
                    <td className={cx("col-cost")}>{line.cost}</td>
                    <td className={cx("col-markup")}>
                      {`$${((line.quantity * line.price * line.markup) / 100).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })} (${line.markup.toFixed(2)} %)`}
                    </td>
                    <td className={cx("col-price")}>
                      $
                      {line.price.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className={cx("col-tax")}>{line.tax}</td>
                    <td className={cx("col-amount")}>
                      $
                      {line.amount.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoiceSections;
